module.exports = __webpack_public_path__ + "img/bootstrap.f8173c78.webp";